var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.77d21cf8718091aa102ff82bd424dd62.svg#bF';
                    var viewUrl = 'sprites.77d21cf8718091aa102ff82bd424dd62.svg#view-bF';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 286 109',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };